var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 29v-2a4 4 0 00-4-4h-7a4 4 0 00-4 4v2m17-13l5 5m0-5l-5 5m-5.5-6a4 4 0 11-8 0 4 4 0 018 0z",
    stroke: "#476FF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNFREYxRkYiLz4KPHBhdGggZD0iTTI0IDI5VjI3QzI0IDI1LjkzOTEgMjMuNTc4NiAyNC45MjE3IDIyLjgyODQgMjQuMTcxNkMyMi4wNzgzIDIzLjQyMTQgMjEuMDYwOSAyMyAyMCAyM0gxM0MxMS45MzkxIDIzIDEwLjkyMTcgMjMuNDIxNCAxMC4xNzE2IDI0LjE3MTZDOS40MjE0MyAyNC45MjE3IDkgMjUuOTM5MSA5IDI3VjI5TTI2IDE2TDMxIDIxTTMxIDE2TDI2IDIxTTIwLjUgMTVDMjAuNSAxNy4yMDkxIDE4LjcwOTEgMTkgMTYuNSAxOUMxNC4yOTA5IDE5IDEyLjUgMTcuMjA5MSAxMi41IDE1QzEyLjUgMTIuNzkwOSAxNC4yOTA5IDExIDE2LjUgMTFDMTguNzA5MSAxMSAyMC41IDEyLjc5MDkgMjAuNSAxNVoiIHN0cm9rZT0iIzQ3NkZGMiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgResourceOut as ReactComponent };